(() => {
  const dialog = document.querySelector('#ShopDrawer');
  if (!dialog) return;
  let frame = dialog.querySelector('[data-shop-frame]');
  const title = dialog.querySelector('h2');
  const status = dialog.querySelector('[data-drawer-status]');
  const fallback = dialog.querySelector('[data-drawer-fallback]');
  let opener, timer, controller, currentMode, currentUrl;
  let version = 0;
  const root = window.Shopify?.routes?.root || '/';
  async function navigate(url, mode) {
    const requestVersion = ++version;
    controller?.abort();
    controller = new AbortController();
    const target = new URL(url, location.origin);
    target.searchParams.set('view', mode === 'cart' ? 'drawer' : 'quick-shop');
    currentMode = mode; currentUrl = target;
    title.textContent = mode === 'cart' ? 'Your box of happy' : 'Make it yours';
    const fullPage = new URL(target); fullPage.searchParams.delete('view');
    fallback.href = fullPage.href;
    status.textContent = mode === 'cart' ? 'Getting your cart ready…' : 'Loading your next favourite…';
    status.hidden = false;
    frame.style.visibility = 'hidden';
    clearTimeout(timer);
    timer = setTimeout(() => { status.textContent = 'Taking a little longer. You can open the full page below.'; }, 15000);
    try {
      const response = await fetch(target, { signal: controller.signal });
      if (!response.ok) throw new Error('Page unavailable');
      const html = await response.text();
      if (requestVersion !== version || !dialog.open) return;
      // Render our own same-origin Shopify document in an isolated app environment.
      // Loading a storefront URL directly in an iframe is disallowed by Shopify.
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const base = parsed.createElement('base'); base.href = target.href; parsed.head.prepend(base);
      const bridge = parsed.createElement('cart-drawer'); bridge.id = 'HbCartBridge'; bridge.hidden = true; parsed.body.prepend(bridge);
      const setup = parsed.createElement('script');
      setup.textContent = `document.getElementById('HbCartBridge').renderContents = function(){parent.hbDrawerCartAdded(window)};`;
      bridge.after(setup);
      // A fresh frame also resets app globals, observers and network wrappers.
      const freshFrame = frame.cloneNode(false);
      freshFrame.removeAttribute('src');
      frame.replaceWith(freshFrame);
      frame = freshFrame;
      frame.addEventListener('load', bindContent);
      const doc = frame.contentDocument;
      doc.open(); doc.write('<!doctype html>' + parsed.documentElement.outerHTML); doc.close();
    } catch (error) {
      if (error.name !== 'AbortError') status.textContent = 'We couldn’t load this just now. Please use the full-page link below.';
    }
  }
  function open(url, mode, trigger) {
    opener = trigger || opener;
    if (!dialog.open) dialog.showModal();
    navigate(url, mode);
  }
  window.hbDrawerCartAdded = source => {
    if (source !== frame.contentWindow || !dialog.open) return;
    document.dispatchEvent(new Event('cart:updated'));
    navigate(`${root}cart`, 'cart');
  };
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[data-quick-shop], a[data-cart-link]');
    if (!link) return;
    event.preventDefault();
    open(link.href, link.hasAttribute('data-cart-link') ? 'cart' : 'product', link);
  });
  dialog.querySelector('[data-close-shop-drawer]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog && event.clientX < dialog.getBoundingClientRect().left) dialog.close(); });
  dialog.addEventListener('close', () => {
    ++version; controller?.abort(); clearTimeout(timer);
    frame.src = 'about:blank';
    document.dispatchEvent(new Event('cart:updated'));
    opener?.focus();
  });
  function bindContent() {
    if (!dialog.open) return;
    const boundWindow = frame.contentWindow;
    const doc = frame.contentDocument;
    if (!doc?.querySelector('.hb-embedded-view') || doc.documentElement.dataset.drawerBound) return;
    doc.documentElement.dataset.drawerBound = 'true';
    clearTimeout(timer); status.hidden = true; frame.style.visibility = 'visible';
    if (currentMode === 'cart') document.dispatchEvent(new Event('cart:updated'));
    doc.addEventListener('keydown', event => { if (event.key === 'Escape' && !doc.querySelector('.neo-popup')) { event.preventDefault(); dialog.close(); } }, true);
    doc.addEventListener('click', event => {
      const checkout = event.target.closest('[name="checkout"]');
      if (checkout) checkout.form.target = '_top';
      else if (event.target.closest('[name="update"]')) {
        const form = event.target.closest('form');
        form.removeAttribute('target');
        form.querySelector('input[name="checkout"]')?.remove();
      }
    }, true);
    doc.addEventListener('click', event => {
      const link = event.target.closest('a');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = new URL(link.href, currentUrl);
      if (target.origin !== location.origin) { link.target = '_top'; return; }
      if (target.pathname.includes('/products/')) { event.preventDefault(); navigate(target.href, 'product'); }
      else if (target.pathname.includes('/collections')) { event.preventDefault(); dialog.close(); }
      else if (target.pathname.includes('/cart/change') && !event.defaultPrevented) {
        event.preventDefault();
        const key = target.searchParams.get('id');
        fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) }).then(response => {
          if (!response.ok) throw new Error('Remove failed');
          navigate(`${root}cart`, 'cart');
        }).catch(() => { status.hidden = false; status.textContent = 'Couldn’t remove that item. Open your full cart to try again.'; });
      }
    });
    doc.querySelectorAll('form[action*="/cart"]').forEach(form => {
      const nativeSubmit = form.submit.bind(form);
      let busy = false;
      const send = async event => {
        if (event?.submitter?.name === 'checkout' || form.target === '_top') {
          if (event) return;
          if (!form.querySelector('input[name="checkout"]')) { const checkout = doc.createElement('input'); checkout.type = 'hidden'; checkout.name = 'checkout'; checkout.value = '1'; form.append(checkout); }
          return nativeSubmit();
        }
        event?.preventDefault();
        if (busy) return;
        if (!form.reportValidity()) return;
        busy = true; form.setAttribute('aria-busy', 'true');
        let error = form.querySelector('[data-drawer-form-error]');
        if (!error) { error = doc.createElement('p'); error.dataset.drawerFormError = ''; error.className = 'form-error'; error.setAttribute('role', 'alert'); form.append(error); }
        error.textContent = '';
        try {
          const endpoint = new URL(form.action).pathname.includes('/cart/add') ? `${root}cart/add.js` : `${root}cart/update.js`;
          const response = await fetch(endpoint, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          const result = await response.json();
          if (!response.ok || result.status >= 400) throw new Error(result.description || 'Please check your choices and try again.');
          document.dispatchEvent(new Event('cart:updated'));
          window.hbDrawerCartAdded(boundWindow);
        } catch (failure) { error.textContent = failure.message || 'Please try again.'; }
        finally { busy = false; form.removeAttribute('aria-busy'); }
      };
      form.addEventListener('submit', send);
      form.submit = () => send();
    });
  }
})();
